import React from 'react';
import {genererViews} from '../../libs/helper';
import Icon from './Icon';

const Views = ({value = 0, type = "", ...props}) => {
    return (
        (type === "icon") ? (
            <div className={`views ${props.className || ""}`}>
                <Icon type="eye"/> {genererViews(value) || 0}
            </div>
        ) : (
            <div className={`views-text ${props.className || ""}`}>
                {value || 0} vues
            </div>
        )
    )
}

export default Views;
